import { useGraphQLQuery } from '@opengov/bnp-core';
import { IPublicationBrandings } from '@opengov/stories-shared/types';

import { graphql } from '../../../../../gql-generated/hasura';
import {
  GetPublicationBrandingsForOnlinePublicationQuery,
  GetPublicationBrandingsForOnlinePublicationQueryVariables
} from '../../../../../gql-generated/hasura/graphql';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { useToast } from '../../../Toast/context/useToast.context';

import {
  PublicationIdKeyParams,
  setupOnlinePublicationQueryKeys
} from './setupOnlinePublicationQueryKeys';

const GetPublicationBrandingsForOnlinePublicationDocument = graphql(`
  query GetPublicationBrandingsForOnlinePublication($id: uuid!) {
    publicationBrandings(where: { publicationId: { _eq: $id } }) {
      id
      idleBackgroundColor
      activeBackgroundColor
      activeFontColor
      createdAt
      enableLogoNavigation
      enableGoogleTranslate
      fontStyle
      idleFontColor
      isNavigationMenuSticky
      logoUrl
      publicationId
      showLogoOnFooter
      updatedAt
    }
  }
`);

export type UsePublicationBrandingsParams = PublicationIdKeyParams | null;

export function usePublicationBrandings(params: UsePublicationBrandingsParams, errorMessage: string) {
  const { toggleToast } = useToast();

  return useGraphQLQuery<
    GetPublicationBrandingsForOnlinePublicationQuery,
    GetPublicationBrandingsForOnlinePublicationQueryVariables,
    IPublicationBrandings | null
  >({
    queryKey: params
      ? setupOnlinePublicationQueryKeys.publicationBrandings(params)
      : ([...setupOnlinePublicationQueryKeys.all, 'publicationBrandings', 'disabled'] as const),
    document: GetPublicationBrandingsForOnlinePublicationDocument,
    url: HASURA_SERVICE_URL,
    variables: params ? { id: params.publicationId } : { id: '' },
    options: {
      enabled: params !== null,
      onError: () => {
        toggleToast({ title: errorMessage, severity: 'error' });
      },
      // Codegen returns nullable columns; the runtime row matches
      // `IPublicationBrandings` once Hasura returns it.
      select: (data: GetPublicationBrandingsForOnlinePublicationQuery): IPublicationBrandings | null => {
        const row = data.publicationBrandings?.[0];
        return row ? (row as unknown as IPublicationBrandings) : null;
      }
    }
  });
}
